import url from './apiUrl'
import handleResponse from './handleResponse'

export default (token, path) => {

    return fetch(`${url()}/${path}`,{
                method: 'GET',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": token
                }
            })
            .then(res => handleResponse(res))
            .catch(err => console.log(err))
}